// this is the contents of the competition.price AWSJSON column. DO NOT CHANGE!
export const priceColumns  = [
  {
    title: 'Price (no VAT)',
    key: 'price'
  },
  {
    title: 'Currency',
    key: 'currency',
    defaultValue: 'EUR'
  },
  {
    title: 'VAT %',
    key: 'vat',
    defaultValue: '20'
  },
  {
    title: 'From',
    key: 'from',
    element: 'dateInput'
  },
  {
    title: 'Until',
    key: 'until',
    element: 'dateInput'
  }
];

export const priceRows = 3;



// WEBPACK FOOTER //
// ./src/private/admin/components/Competition/Panes/awsjson.price.js